import PropTypes from 'prop-types';
import classNames from 'clsx';

import PillButton from './PillButton';

import css from './pill-button.module.scss';

const CoralButton = ({ className, ...otherProps }) => (
  <PillButton className={classNames(className, css.coral)} {...otherProps} />
);

CoralButton.propTypes = {
  className: PropTypes.string,
};

export default CoralButton;
